module.exports = __webpack_public_path__ + "img/articles2.c486ab87.svg";